<template>
  <div id="mri-results-text" :class="classes">
      <span v-if="$store.state.showDetailedInfo">
        <p v-for="copy in copyData[year].copy" :key="copy" v-html="copy"></p>
      </span>
  </div>
</template>
<script>
import progressionMixin from "@/mixins/progressionMixin";

export default {
  name: "MriResultsText",
  mixins: [progressionMixin],
  computed: {
    year() {
      return this.$store.state.year;
    }
  },
  data() {
    return {
      copyData: {
        0: {
          copy: [
            "T1-weighted, T2-weighted, and T2-weighted fluid-attenuated inversion recovery (FLAIR) magnetic resonance images (MRI) (3T) in a healthy brain, showing no lesions.<sup>6</sup>"
          ]
        },
        1: {
          copy: [
            "A T2-weighted FLAIR image (left) and a T1-weighted image (right) of the brain illustrate multiple lesions. Early neuropathology in MS is characterized by lesions and subtle changes in brain volume.<sup>2</sup>"
          ]
        },
        2: {
          copy: [
            "In the early stages of RRMS, pathology is dominated by focal inflammatory lesions often associated with subtle symptoms, most commonly fatigue, vision, and sensory issues.<sup>5,13</sup>"
          ]
        },
        3: {
          copy: [
            "Within each subtype (RRMS and SPMS), the disease can be classified as active or not active, defined by the occurrence of lesions on an MRI.<sup>18</sup>"
          ]
        },
        4: {
          copy: [
            "Lesion volume early in the disease course correlates with higher disability in 20 years.<sup>22</sup> The initiation of disease-modifying therapies aims to reduce the formation of lesions early in the disease course, to slow the accumulation of disability.<sup>23​</sup>"
          ]
        },
        5: {
          copy: [
            "Lesion-load measures on MRI are associated only weakly with physical disability.<sup>27</sup>"
          ]
        },
        6: {
          copy: [
            "In this set of scans, there is diffuse lesions and increasing atrophy observable in the brain.​"
          ]
        },
        7: {
          copy: [
            "Lesions can appear on MRI without any progression in physical disability, and conversely, patients can progress in disability without the appearance of new lesions.<sup>21</sup>",
            "Most individual lesions in RRMS expand over time (46%), while others stay stable (42%), and a minor proportion shrinks (12%). Overall, new lesions appear over time and the overall lesion volume in the brain increases.<sup>31​</sup>​"
          ]
        },
        8: {
          copy: [
            "Lesion load may predict long-term cognitive dysfunction, in particular focal white matter damage.<sup>35</sup>"
          ]
        },
        9: {
          copy: [
            "Ventricular cerebrospinal fluid space enlargement is an important MRI predictor for disability progression from the earliest clinical stages.<sup>39</sup>"
          ]
        },
        10: {
          copy: [
            "MS patients with disability progression show more advanced gray matter atrophy at 10 years compared to stable patients.<sup>43</sup>"
          ]
        },
        11: {
          copy: [
            "​As the disease progresses, inflammatory activity decreases and active lesions become less common, as seen in these two images.<sup>24,44</sup>"
          ]
        },
        12: {
          copy: [
            "During the SPMS stage, neuropathology is characterized increasingly by brain volume loss, which is in turn associated with disease progression and sustained disability.<sup>44</sup>"
          ]
        },
        13: {
          copy: [
            "Patients with SPMS also show accelerated cortical gray matter atrophy compared to those with RRMS.<sup>43</sup>"
          ]
        },
        14: {
          copy: [
            "Plaques occur in both white matter and gray matter and are typically found throughout the central nervous system, including in the brain, optic nerve, and spinal cord.<sup>18</sup>"
          ]
        },
        15: {
          copy: [
            "In SPMS, diffuse pathological features are more prominent in the white and gray matter, including microglial activation and neurodegeneration on cortical histopathology.<sup>5</sup>"
          ]
        },
        16: {
          copy: [
            "Brain atrophy seems to be widespread in MS, affecting multiple brain regions, including the cerebral lobes, white-matter tracts, brainstem, and cerebellum.<sup>27</sup>"
          ]
        },
        17: {
          copy: [
            "There is increasing evidence that brain atrophy is not restricted to later in the disease course, but instead begins in the earliest stages of MS.<sup>27</sup>"
          ]
        },
        18: {
          copy: [
            "Spinal cord atrophy shows relations with physical disability, while whole-brain parenchymal volume is correlated with cognitive function.<sup>27</sup>"
          ]
        },
        19: {
          copy: [
            "The annual rates of atrophy are similar between RRMS and SPMS, with rates between 0.6 and 0.8% per year, vs <0.1% per year for healthy controls.<sup>27</sup>"
          ]
        },
        20: {
          copy: [
            "The initiation of disease-modifying therapies aims to reduce the formation of lesions early in the disease course to prevent accumulation of disability. These therapies can help control the processes involved in the disease, such as inflammation, and to slow disease progression.<sup>8</sup>"
          ]
        }
      }
    };
  }
};
</script>

<style lang="scss">
#mri-results-text {
  &.subtitle {
    position: relative;
    top: 0;
    right: auto;
    width: 80%;
  }
}
</style>